import { render, staticRenderFns } from "./LimitSlideByPlan.vue?vue&type=template&id=3c04f8bf&scoped=true&"
import script from "./LimitSlideByPlan.vue?vue&type=script&lang=js&"
export * from "./LimitSlideByPlan.vue?vue&type=script&lang=js&"
import style0 from "./LimitSlideByPlan.vue?vue&type=style&index=0&id=3c04f8bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04f8bf",
  null
  
)

export default component.exports